function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { TextInput as MantineTextInput } from "@mantine/core";
import { mergeRefs } from "@mantine/hooks";
import { useStyles as useInputStyles } from "../input/Input";
var TextInput = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var isRequired = _param.isRequired, isDisabled = _param.isDisabled, isReadOnly = _param.isReadOnly, classNames = _param.classNames, libraryProps = _param.libraryProps, props = _objectWithoutProperties(_param, [
        "isRequired",
        "isDisabled",
        "isReadOnly",
        "classNames",
        "libraryProps"
    ]);
    var _$ref2 = _slicedToArray(React.useState(false), 2), hasValue = _$ref2[0], setHasValue = _$ref2[1];
    var _$ref1 = _slicedToArray(React.useState(false), 2), hasFocus = _$ref1[0], setHasFocus = _$ref1[1];
    var isActive = hasFocus || hasValue;
    // On mount, check whether we have a value.
    var internalRef = React.useRef(null);
    React.useEffect(function() {
        var _$ref;
        if ((_$ref = internalRef.current) === null || _$ref === void 0 ? void 0 : _$ref.value) {
            setHasValue(true);
        }
    }, [
        props.defaultValue
    ]);
    var styleProps = _objectSpread({
        hasFocus: hasFocus,
        isActive: isActive,
        disabled: isDisabled
    }, props);
    var classes = useInputStyles(styleProps, {
        classNames: classNames
    }).classes;
    return /*#__PURE__*/ _jsx(MantineTextInput, _objectSpread({}, libraryProps, props, {
        ref: mergeRefs(internalRef, ref),
        required: isRequired,
        disabled: isDisabled,
        readOnly: isReadOnly,
        onFocus: function(e) {
            var _$ref;
            setHasFocus(true);
            (_$ref = props.onFocus) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
        },
        onBlur: function(e) {
            var _$ref;
            setHasFocus(false);
            (_$ref = props.onBlur) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
        },
        onChange: function(e) {
            var _$ref;
            setHasValue(!!e.target.value);
            (_$ref = props.onChange) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
        },
        classNames: _objectSpread({}, classNames, classes)
    }));
});
export { TextInput };
